enum EntityType {
  Product = 'Product',
  Customer = 'Customer',
  Category = 'Category',
  Task = 'Task',
  Comment = 'Comment',
  BlogPost = 'BlogPost',
  News = 'News',
  Setting = 'Setting',
  AgentCustomer = 'AgentCustomer',
  SpecificationAttributeOption = 'SpecificationAttributeOption',
  SpecificationAttribute = 'SpecificationAttribute',
  SpecificationAttributeDisplay = 'SpecificationAttributeDisplay',
  Sharing = 'Sharing',
  Topic = 'Topic',
  Address = 'Address',
  TaxCategory = 'TaxCategory',
  Language = 'Language',
  Paralist = 'Paralist',
  Country = 'Country',
  City = 'City',
  Municipality = 'Municipality',
  Guest = 'Guest',
  Chat = 'Chat',
}

export default EntityType;
